import React from 'react';
import { ReactComponent as EyeIcon } from "../../../assets/icons/eye.svg"

interface GInputProps {
  label?: string;
  type?: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  validate?: () => any;
}

const GInput: React.FC<GInputProps> = ({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  className = '',
  required = false,
  disabled = false,
  validate,
  ...props
}) => {
  const inputId = React.useId();
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading,setLoading] = React.useState(false);
  const [validateData, setValidateData] = React.useState<any>(null);

  const onValidate = async () => {
    if (validate) {
      setLoading(true)
     const data =  await validate();
     console.log({validateData});
     setValidateData(data)
     setLoading(false)
    }
  }
  return (
    <div className="mb-5">
      {label && (
        <label htmlFor={inputId} className="block text-white/75 text-[14px] font-bold uppercase tracking-widest mb-[8px]">
          {label}
        </label>
      )}
      <div className="relative group">
        <input
          id={inputId}
          type={type === 'password' && showPassword ? 'text' : type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          className={`px-5 py-[14px] bg-white/[0.06] border border-white/[0.1] rounded-[12px] text-white text-[15px] font-medium placeholder-white/25 focus:outline-none focus:border-[#4DBDFF]/50 focus:bg-white/[0.1] focus:shadow-[0_0_20px_rgba(0,134,211,0.12),inset_0_0_20px_rgba(0,134,211,0.05)] transition-all duration-300 ${className}`}
          {...props}
        />
        {type === 'password' && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 w-[35px] h-[35px]">
            <button type="button" className="text-white/30 hover:text-white/60 transition-colors duration-200" onClick={() => setShowPassword(!showPassword)}>
              {!showPassword && (
                <div className="absolute w-full h-[2px] bg-white/30 rotate-45 top-1/2"></div>
              )}
              <EyeIcon width={35} height={35} fill="currentColor" />
            </button>
          </div>
        )}
        {validate &&
          <button className={`absolute right-3 top-1/2 transform -translate-y-1/2 text-[#fff] hover:text-[#fff] transition-colors duration-200  bg-[#4DBDFF] ${validateData?.validatePromoCode?.isValid &&  'bg-green-500'} ${!validateData?.validatePromoCode?.isValid && 'bg-red-500'} px-3 py-1 rounded-[8px]` } 
           onClick={onValidate} disabled={loading}>
            {loading && <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>}
            {(!validateData && !loading) && 'Verify'}
            {(validateData && validateData?.validatePromoCode?.isValid && !loading) && 'Valid'}
            {(validateData && !validateData?.validatePromoCode?.isValid && !loading) &&  'Invalid'}
          </button>}
      </div>
    </div>
  );
};

export default GInput;